<template>
  <div class="view__view view-reclamation">
    <div class="view__headline">
      <span class="heading beta -color-white">Reklamationsgrund</span>
    </div>
    <div class="view__form form">
      <div class="field__wrap">
        <div class="col selectbox">
          <input class="select-input" readonly @focusin="open = true"/>
          <div class="selected icon-caret-down-after"><span v-if="reasons.selectedReason">{{reasons.selectedReason}}</span><span v-else>Bitte wählen</span></div>
          <div class="select-items" :class="{'-open': open}">
            <div v-for="(reason, index ) in reasons.getReasons" class="item" @click="reasons.selectedReason = reason;reasons.selectedReasonIndex = index;open = false" :key="index">{{reason}}</div>
          </div>
        </div>
      </div>
      <div class="field__wrap" v-if="reasons.selectedReason === 'Sonstiges (bitte Freitext nutzen)'">
        <div class="col">
          <TextInput identifier="otherReclamation" placeholder="Sonstiger Grund"
                     :value="reasons.otherReason"
                     @update="reasons.otherReason = $event"></TextInput>
        </div>
      </div>
    </div>
    <div class="cta-wrapper">
      <button class="-btn-beta" @click="handleSubmit"><span>Zustellung auswählen</span></button>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/Input/TextInput.vue';
import { useViewStore } from '@/stores/view';

import { useReasonStore } from '@/stores/reason';

export default {
  name: 'DeliveryEntry',
  components: {
    TextInput,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    handleSubmit() {
      if (this.reasons.selectedReason) {
        this.view.update('DeliveryEntry', this.view.counter + 1);
      }
    },
  },
  setup() {
    const view = useViewStore();
    const reasons = useReasonStore();
    return {
      reasons,
      view,
    };
  },
};
</script>
